import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    assignRelevantPeopleList: () => {
        return HTTP.get('/account/assign_relevant_people', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addCapital: (data) => {
        return HTTP.post('/account/capital_create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editCapital: (id,data) => {
        return HTTP.post('/account/capital_update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailCapital: (id) => {
        return HTTP.get('/account/capital_edit/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addCreditor: (data) => {
        return HTTP.post('/account/creditor_create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editCreditor: (id,data) => {
        return HTTP.post('/account/creditor_update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailCreditor: (id) => {
        return HTTP.get('/account/creditor_edit/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addDebtor: (data) => {
        return HTTP.post('/account/debtor_create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editDebtor: (id,data) => {
        return HTTP.post('/account/debtor_update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailDebtor: (id) => {
        return HTTP.get('/account/debtor_edit/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    deleteDebtor: (id) => {
        return HTTP.post('/account/debtor_delete/'+id,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}